import { put, take } from 'redux-saga/effects';

import { GET_PAGE_BREAKS_FAIL } from 'PipeRouter';

import { HIDE_PAGE_SELECTOR } from 'Reducers/compModels';


function* getPageBreaksFail() {
  while(true) {
    yield take(GET_PAGE_BREAKS_FAIL);

    yield put({
      type: 'HIDE_PAGE_SELECTOR'
    });
  }
}


export default getPageBreaksFail;
